// V1's new-quote customer selection merges customer details into the draft.
// RFQ, references, notes, required date and quote-specific choices stay intact.
export function selectQuoteCustomer(draft, customer, defaults, paymentTermsOverridden) {
  const hasCustomerLeadTime = Boolean(customer?.lead_time_text) || customer?.lead_time_days != null;
  return {
    ...draft,
    customer_id: defaults.customer_id,
    contact_id: defaults.contact_id,
    shipping_location_id: defaults.shipping_location_id,
    valid_until: defaults.valid_until,
    lead_time_text: customer?.lead_time_text || (customer?.lead_time_days != null ? defaults.lead_time_text : draft.lead_time_text || defaults.lead_time_text),
    lead_time_days: hasCustomerLeadTime ? customer.lead_time_days ?? null : draft.lead_time_days ?? defaults.lead_time_days ?? null,
    payment_terms: paymentTermsOverridden===true?draft.payment_terms:paymentTermsOverridden===false?defaults.payment_terms:customer?.payment_terms||draft.payment_terms||defaults.payment_terms,
    tier_override: customer?.tier || draft.tier_override || defaults.tier_override,
  };
}
